import React from 'react';
import '../AboutUs.css';
import shekil from '../svg_proekt/aboutUs/aboutus.jpg';

function AboutUs() {
    return (
        <div className="dflex jc-center aboutUs">
            <div className="w74">
                <img src={shekil} alt="" width="100%"></img>
                <h4>
                    Hello, my name is Cahangir Qanizade and im happy that your surfing in my website.
                    <br />
                    I have been studying in <a href="https://www.instagram.com/codersazerbaijan/">Coders Azerbaijan</a> courses since 22 April 2021 till 22 July 2021.
                    I want to thank every member of this course who was helping me to get every information which i need to build websites.
                    During this course my teachers was Nijat Mammadli, Jamal Huseynov, Emil Farmanli, Emin Qarayev.
                    Especially i want to thank Nijat Mammadli for in my opinion best possible start.
                    <br/>
                    If you cannot do websites and you want at least do like me or better , just do not stop , study and work hard.
                    Do not let laziness take dominance.
                </h4>
            </div>
        </div>
    );
};

export default AboutUs;
